import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
// StickyCTA ("Download App" floating button) hidden pre-launch
// import StickyCTA from "@/components/StickyCTA";
import Hero from "@/components/sections/Hero";
import Features from "@/components/sections/Features";
import Industries from "@/components/sections/Industries";
import Benefits from "@/components/sections/Benefits";
import Screenshots from "@/components/sections/Screenshots";
// Testimonials hidden pre-launch (no real customers yet)
// import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import About from "@/components/sections/About";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import DownloadCTA from "@/components/sections/DownloadCTA";
import Footer from "@/components/sections/Footer";
import Terms from "@/pages/Terms";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import DeleteAccount from "@/pages/DeleteAccount";

const Home = () => (
  <main data-testid="home-page">
    <Navbar />
    <Hero />
    <Features />
    <Industries />
    <Benefits />
    <Screenshots />
    {/* <Testimonials /> hidden pre-launch */}
    <Pricing />
    <About />
    <FAQ />
    <Contact />
    <DownloadCTA />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/foliostax/terms" element={<Terms />} />
          <Route path="/foliostax/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/foliostax/delete-account" element={<DeleteAccount />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
